import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, first, filter } from 'rxjs/operators';
import { GetParameters } from 'src/app/parameters/store/parameter.actions';
import { getBooleanParameterIfParameterWasLoaded } from 'src/app/parameters/store/parameter.reducer';

export const TrackerModeGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const entitlementMode$ = store.select(getBooleanParameterIfParameterWasLoaded('QCTRACKER1'));
  store.dispatch(GetParameters());
  return entitlementMode$.pipe(
    filter((mode) => mode !== null),
    map((mode) => mode),
    first()
  );
};
